@if (inputService.show) {
  <ng-container [formGroup]="inputService.formGroup">
    <mat-form-field [appearance]='inputService.inputConfig.appearence'>
      <mat-label>
        @if (inputService.formInputDefinition.titleIcon) {
          <mat-icon class='title-input-icon' [matTooltip]='inputService.formInputDefinition.titleTooltip'>{{inputService.formInputDefinition.titleIcon}}</mat-icon>
        }
        <span>{{inputService.computedTitle | translate}}</span>
      </mat-label>
      @if (inputService.inputConfig.readOnly) {
        <input matInput readonly [required]='inputService.inputConfig.required' [value]='selectedLabel' />
      }
      @if (!inputService.inputConfig.readOnly) {
        <mat-select [required]='inputService.inputConfig.required' [placeholder]="inputService.inputConfig.placeholder | translate" [formControlName]='inputService.formControlKey'>
          <input class="myInput"
            matInput
            selectPanelSearch
            type="text"
            (input)="search($event.target.value)"
            autocomplete="off"
            [placeholder]="'Cerca' | translate">
          @if (loading) {
            <mat-progress-bar mode='indeterminate' ></mat-progress-bar>
          }
          <mat-divider></mat-divider>
          @for (selectOption of selectOptions; track selectOption) {
            <mat-option [value]='selectOption.value'>
              @if (inputService.formInputDefinition.remoteOptions.icon) {
                <mat-icon>{{inputService.formInputDefinition.remoteOptions.icon}}</mat-icon>
              }
              <span [innerHTML]='selectOption.label'></span>
            </mat-option>
          }
        </mat-select>
      }
      @if (loading) {
        <mat-spinner diameter="20" matSuffix></mat-spinner>
      }
      @if (!loading && inputService.control.value && !inputService.inputConfig.readOnly) {
        <mat-icon matSuffix style='cursor: pointer;' (click)='inputService.control.setValue(null)'>close</mat-icon>
      }
      <!-- mat-hint here generate an error, need to investigate -->
      <!--<mat-hint *ngIf='inputService.inputConfig.hint'>{{inputService.inputConfig.hint}}</mat-hint>-->
      @if (!inputService.control.valid && inputService.errorMessage) {
        <mat-error>{{inputService.errorMessage | translate}}</mat-error>
      }
    </mat-form-field>
  </ng-container>
}